
export const featuredPosters = [
  {
    id: '1',
    src: 'https://static.readdy.ai/image/55007b31e14c3def396c32a0945c7f13/d1cef3c577a387d79d415a030a4a1c3c.jpeg',
    title: 'TRĂNG ĐIÊN',
    description: '',
    category: 'WEB DRAMA',
    director: 'Quách Ngọc Tuyên',
    year: 2025
  },
  {
    id: '2',
    src: 'https://static.readdy.ai/image/55007b31e14c3def396c32a0945c7f13/a237d1b5585f1155d70639f8798c52da.jpeg',
    title: 'CUỘC CHIẾN HẠ LƯU',
    description: '',
    category: 'WEB DRAMA',
    director: 'VIEON ORIGINAL',
    year: 2024
  },
  {
    id: '3',
    src: 'https://static.readdy.ai/image/55007b31e14c3def396c32a0945c7f13/7bb0f9e560cfa6442b349c39e6fbb9f6.png',
    title: 'VIBEGLO',
    description: '',
    category: 'MUSIC VIDEO',
    director: 'ĐÀO TỬ AJ1',
    year: 2024
  },
  {
    id: '4',
    src: 'https://static.readdy.ai/image/55007b31e14c3def396c32a0945c7f13/154ca66485e38f12ad7ffdd4f4f758c5.jpeg',
    title: 'BI LONG ĐẠI CA',
    description: '',
    category: 'WEB DRAMA',
    director: 'ATO FILM GROUP',
    year: 2024
  },
  {
    id: '5',
    src: 'https://static.readdy.ai/image/55007b31e14c3def396c32a0945c7f13/f6cfc677548280ca9cb910b3e9aa37b3.jpeg',
    title: 'TƯƠNG SINH TƯƠNG KHẮC',
    description: '',
    category: 'WEB DRAMA',
    director: 'THANH TÂN OFFICIAL',
    year: 2024
  },
  {
    id: '6',
    src: 'https://static.readdy.ai/image/55007b31e14c3def396c32a0945c7f13/a2d2c4f1c5b4adc016efe6c14118a24f.jpeg',
    title: 'THANH XUÂN NỢ CUỘC ĐỜI',
    description: '',
    category: 'MUSIC VIDEO',
    director: 'GRAMMY MUSIC VIETNAM',
    year: 2024
  },
  {
    id: '7',
    src: 'https://static.readdy.ai/image/55007b31e14c3def396c32a0945c7f13/fc12e8a6485e032db5009735fa57effe.jpeg',
    title: 'YÊU LẠI TỪ ĐẦU',
    description: '',
    category: 'WEB DRAMA',
    director: 'VIỆT HƯƠNG',
    year: 2024
  },
  {
    id: '8',
    src: 'https://static.readdy.ai/image/55007b31e14c3def396c32a0945c7f13/f5e4027fd5e7e68645dc1092fd850d09.png',
    title: 'MỘT NỬA SỰ THẬT',
    description: '',
    category: 'WEB DRAMA',
    director: 'NÀNG PƠ LANG FILM',
    year: 2024
  },
  {
    id: '9',
    src: 'https://static.readdy.ai/image/55007b31e14c3def396c32a0945c7f13/f7378c8607d762f1f13b48b5623ed931.png',
    title: 'NỤ HÔN KÝ ỨC',
    description: '',
    category: 'WEB DRAMA',
    director: 'VLIVE.TV',
    year: 2024
  },
  {
    id: '10',
    src: 'https://static.readdy.ai/image/55007b31e14c3def396c32a0945c7f13/1c8b40051c37092e32aacb377d99980c.png',
    title: 'CHỜ RẠNG ĐÔNG',
    description: '',
    category: 'MUSIC VIDEO',
    director: 'A FISHY BIT',
    year: 2024
  },
  {
    id: '11',
    src: 'https://static.readdy.ai/image/55007b31e14c3def396c32a0945c7f13/ef20cd3ba4e44f32f6914a3db0955db3.png',
    title: 'VỆ THẦN TÌNH YÊU',
    description: '',
    category: 'WEB DRAMA',
    director: 'LALA SCHOOL',
    year: 2024
  },
  {
    id: '12',
    src: 'https://static.readdy.ai/image/55007b31e14c3def396c32a0945c7f13/29a63bd891a5a25134695ef1009bdacd.png',
    title: 'LAN QUẾ PHƯỜNG',
    description: '',
    category: 'WEB DRAMA',
    director: 'LALA SCHOOL',
    year: 2024
  },
  {
    id: '13',
    src: 'https://static.readdy.ai/image/55007b31e14c3def396c32a0945c7f13/8ccd161dbde1c73441eba76beb8fee4e.png',
    title: 'CÚP ĐIỆN',
    description: '',
    category: 'FASHION VIDEO',
    director: 'DUC STUDIO',
    year: 2024
  },
  {
    id: '14',
    src: 'https://static.readdy.ai/image/55007b31e14c3def396c32a0945c7f13/819e31322c8a9030532dcbc8d28cb0b5.png',
    title: 'SAND MAN',
    description: '',
    category: 'FASHION VIDEO',
    director: 'T-REDX',
    year: 2024
  },
  {
    id: '15',
    src: 'https://static.readdy.ai/image/55007b31e14c3def396c32a0945c7f13/797f57d5b21e0ea21983c2a9add82b3a.png',
    title: 'NINE TO MEET THEM ALL AGAIN',
    description: '',
    category: 'FASHION VIDEO',
    director: 'LIDER',
    year: 2024
  },
  {
    id: '16',
    src: 'https://static.readdy.ai/image/55007b31e14c3def396c32a0945c7f13/735fa04765655ffc56287c8f5d94f6a4.jpeg',
    title: 'AW24 COLLECTION',
    description: '',
    category: 'FASHION VIDEO',
    director: 'AESIR STUDIO',
    year: 2024
  },
  {
    id: '17',
    src: 'https://static.readdy.ai/image/55007b31e14c3def396c32a0945c7f13/4a82582e68defe3c3f5e43c5effb0e04.png',
    title: 'CHOCODIPPING',
    description: '',
    category: 'TVC',
    director: 'Puratos Grand-Place',
    year: 2024
  },
  {
    id: '18',
    src: 'https://static.readdy.ai/image/55007b31e14c3def396c32a0945c7f13/cb6bd8308d6487c5ea654daffa233313.png',
    title: 'BỐ ĐỈNH',
    description: '',
    category: 'TVC',
    director: 'FPT SHOP',
    year: 2024
  },
  {
    id: '19',
    src: 'https://static.readdy.ai/image/55007b31e14c3def396c32a0945c7f13/02125d61fbf896658daeca8f606f5b07.png',
    title: 'TOKYO MARATHON',
    description: '',
    category: 'TVC',
    director: 'POCARI SWEAT',
    year: 2024
  },
  {
    id: '20',
    src: 'https://static.readdy.ai/image/55007b31e14c3def396c32a0945c7f13/a037a7b0671b3fcca94b4ab132c1e8d2.jpeg',
    title: 'UNOW',
    description: '',
    category: 'TVC',
    director: 'UNILEVER',
    year: 2024
  },
  {
    id: '21',
    src: 'https://static.readdy.ai/image/55007b31e14c3def396c32a0945c7f13/81dedc7e51c8284494f25272a14be8dc.jpeg',
    title: 'BÃO QUÀ 68 TỶ',
    description: '',
    category: 'TVC',
    director: 'DAIKIOSAN',
    year: 2024
  },
  {
    id: '22',
    src: 'https://static.readdy.ai/image/55007b31e14c3def396c32a0945c7f13/6e1aa264fe5964e8c493a864aac6aa3c.png',
    title: 'SOMETIMES MIXTAPE',
    description: '',
    category: 'MUSIC VIDEO',
    director: 'A FISHY BIT',
    year: 2024
  }
];

export const recentWorks = [
  {
    id: '11',
    src: 'https://static.wixstatic.com/media/dff8fa_ebebb4ad245247b19d9cfe70a7905c7f~mv2.jpeg/v1/fill/w_88,h_50,al_c,q_80,usm_0.66_1.00_0.01/dff8fa_ebebb4ad245247b19d9cfe70a7905c7f~mv2.jpeg',
    title: 'Tác phẩm mới nhất 1'
  },
  {
    id: '12',
    src: 'https://static.wixstatic.com/media/dff8fa_dd22782f75744d5e92f4b3377caf4e27~mv2.jpeg/v1/fill/w_88,h_50,al_c,q_80,usm_0.66_1.00_0.01/dff8fa_dd22782f75744d5e92f4b3377caf4e27~mv2.jpeg',
    title: 'Tác phẩm mới nhất 2'
  },
  {
    id: '13',
    src: 'https://static.wixstatic.com/media/dff8fa_84fea1484c924a44b06d49c0ef38f458~mv2.jpeg/v1/fill/w_88,h_50,al_c,q_80,usm_0.66_1.00_0.01/dff8fa_84fea1484c924a44b06d49c0ef38f458~mv2.jpeg',
    title: 'Tác phẩm mới nhất 3'
  },
  {
    id: '14',
    src: 'https://static.wixstatic.com/media/dff8fa_a006f53fd30f4379a779cceb1f1b4e5f~mv2.jpeg/v1/fill/w_88,h_50,al_c,q_80,usm_0.66_1.00_0.01/dff8fa_a006f53fd30f4379a779cceb1f1b4e5f~mv2.jpeg',
    title: 'Tác phẩm mới nhất 4'
  },
  {
    id: '15',
    src: 'https://static.wixstatic.com/media/dff8fa_4adc0e69b720499d9fd1bdc5c7ec8b2e~mv2.jpeg/v1/fill/w_88,h_50,al_c,q_80,usm_0.66_1.00_0.01/dff8fa_4adc0e69b720499d9fd1bdc5c7ec8b2e~mv2.jpeg',
    title: 'Tác phẩm mới nhất 5'
  },
  {
    id: '16',
    src: 'https://static.wixstatic.com/media/dff8fa_ed9d046d441947f4a1bf4e4a39c8f94d~mv2.jpeg/v1/fill/w_88,h_50,al_c,q_80,usm_0.66_1.00_0.01/dff8fa_ed9d046d441947f4a1bf4e4a39c8f94d~mv2.jpeg',
    title: 'Tác phẩm mới nhất 6'
  },
  {
    id: '17',
    src: 'https://static.wixstatic.com/media/dff8fa_cf80f00fe40b4cecbb83a6afe2704a1b~mv2.jpeg/v1/fill/w_88,h_50,al_c,q_80,usm_0.66_1.00_0.01/dff8fa_cf80f00fe40b4cecbb83a6afe2704a1b~mv2.jpeg',
    title: 'Tác phẩm mới nhất 7'
  },
  {
    id: '18',
    src: 'https://static.wixstatic.com/media/dff8fa_a6db7089915748d58920856e8a737cad~mv2.jpeg/v1/fill/w_88,h_50,al_c,q_80,usm_0.66_1.00_0.01/dff8fa_a6db7089915748d58920856e8a737cad~mv2.jpeg',
    title: 'Tác phẩm mới nhất 8'
  },
  {
    id: '19',
    src: 'https://static.wixstatic.com/media/dff8fa_48fe4e8f96dd44a3b7ee57958bb5549c~mv2.jpeg/v1/fill/w_88,h_50,al_c,q_80,usm_0.66_1.00_0.01/dff8fa_48fe4e8f96dd44a3b7ee57958bb5549c~mv2.jpeg',
    title: 'Tác phẩm mới nhất 9'
  },
  {
    id: '20',
    src: 'https://static.wixstatic.com/media/dff8fa_b6f60c27a86f43aea3bd11a1a74f7790~mv2.jpeg/v1/fill/w_88,h_50,al_c,q_80,usm_0.66_1.00_0.01/dff8fa_b6f60c27a86f43aea3bd11a1a74f7790~mv2.jpeg',
    title: 'Tác phẩm mới nhất 10'
  },
  {
    id: '21',
    src: 'https://static.wixstatic.com/media/dff8fa_9346cbf929ac402697616bc0a5d3e981~mv2.jpeg/v1/fill/w_88,h_50,al_c,q_80,usm_0.66_1.00_0.01/dff8fa_9346cbf929ac402697616bc0a5d3e981~mv2.jpeg',
    title: 'Tác phẩm mới nhất 11'
  }
];

export const awards = [
  {
    year: '2024',
    awards: [
      'Giải Poster Xuất sắc - Liên hoan phim Quốc tế',
      'Thiết kế Poster Tốt nhất - Festival Điện ảnh Việt Nam'
    ]
  },
  {
    year: '2023',
    awards: [
      'Giải Thưởng Thiết kế Đồ họa - Hội Điện ảnh',
      'Poster Ấn tượng nhất - Tuần lễ Phim Châu Á'
    ]
  },
  {
    year: '2022',
    awards: [
      'Thiết kế Visual Identity Xuất sắc',
      'Giải Bạc - Cuộc thi Poster Điện ảnh'
    ]
  }
];
